import { useCallback } from 'react';
import { useComponentTranslations } from 'js/hooks/component/useComponentTranslations';

import * as helpers from '../helpers';
import { MAX_PERIOD_YEARS } from '../constants';

export const useValidate = () => {
    const translate = useComponentTranslations();

    return useCallback(({ from: fromDate, until: untilDate }) => {
        const from = helpers.intoDate(fromDate);
        const until = helpers.intoDate(untilDate);
        const rangeError = translate('filter.error.range');
        const timePeriodError = translate('filter.error.timePeriod');

        if (from > until) {
            return { from: timePeriodError, until: timePeriodError };
        }

        const startOfToday = helpers.startOfDay(new Date());

        if (until.getTime() >= startOfToday.getTime()) {
            return { until: translate('filter.error.after') };
        }

        if (helpers.hasYearsDiffStrict(from, until, MAX_PERIOD_YEARS)) {
            return { from: rangeError, until: rangeError };
        }
    }, [translate]);
};
